import {Component, ElementRef, OnInit, Renderer2, OnDestroy, AfterViewInit, AfterViewChecked} from '@angular/core';
import {ModalDialogV3} from '../../../shared-modal-dynamic/models/modal-dialog-v3';
import {ActionMenuSettingsModel} from '../../models/action-menu-settings-model';
import {ModalResultModel} from '../../../shared-modal-dynamic/models/modal-result-model';
import {ActionMenuItemModel} from '../../models/action-menu-item-model';
import {
    BaseOutsideClickScrollEventListenerDirective
} from '../../../shared-forms/directives/base-outside-click-scroll-event-listener.directive';

@Component({
    selector: 'app-modal-actions-menu',
    templateUrl: './modal-actions-menu.component.html',
    styleUrl: './modal-actions-menu.component.scss'
})
export class ModalActionsMenuComponent extends ModalDialogV3 implements OnInit, OnDestroy {

    setting = {} as ActionMenuSettingsModel;
    menuPosition = {x: 0, y: 0};  // Position of the menu from screen top and right
    clickCatcherPosition = {x: 0, y: 0}; // click catcher avoid reopening the menu when clicking to the click source button once again
    private eventListenerUtils: BaseOutsideClickScrollEventListenerDirective;

    initialized = false;

    constructor(private renderer: Renderer2, private elementRef: ElementRef) {
        super();
        // extends two base classes is not possible,
        // so we use a directive instance to handle outside clicks and scroll events
        this.eventListenerUtils = new BaseOutsideClickScrollEventListenerDirective(renderer, elementRef);
    }

    ngOnInit() {
        this.setting = (this.modalParams.model as ActionMenuSettingsModel);

        this.menuPosition = {...this.setting.position} || {x: 0, y: 0};
        this.menuPosition.x += this.setting.position.deltaX || 0; // Adjust for deltaX if provided

        this.clickCatcherPosition = {...this.setting.position} || {x: 0, y: 0};


        // Delegate event handling to the directive
        this.eventListenerUtils.debugId = this.setting.debugId;
        this.eventListenerUtils.onOutsideClick = () => this.onOutsideClick();
        this.eventListenerUtils.onScroll = () => this.onScroll();
        this.eventListenerUtils.registerListeners();


        setTimeout(() => {
            // Adjust position to ensure the menu is fully visible
            this.adjustMenuPosition()
            this.initialized = true; // without this, the menu can be closed by the click which opened it
        });
    }


    onScroll() {
        console.log('Scroll detected, closing the modal', this.setting.debugId);
        this.announceModelChanged({action: null} as ModalResultModel<any>);
        this.close();
    }

    onOutsideClick() {
        if (!this.initialized) {
            return;
        }
        console.log('Clicked outside the modal', this.setting.debugId);
        this.announceModelChanged({action: null} as ModalResultModel<any>);
        this.close();
    }

    onMenuItemClick(menuItem: ActionMenuItemModel) {
        this.announceModelChanged({action: menuItem.actionId} as ModalResultModel<any>);
        this.close();
    }

    private adjustMenuPosition() {
        const menuElement = this.elementRef.nativeElement.querySelector('.modal-actions-menu');
        if (menuElement) {
            const rect = menuElement.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            if (rect.bottom > viewportHeight - 10) { // Add padding 10px
                const overflow = rect.bottom - viewportHeight;
                this.menuPosition.y -= overflow + 10; // Add padding 10px
            }
        }
    }

    ngOnDestroy() {
        console.log('ModalActionsMenuComponent ngOnDestroy', this.setting.debugId);
        this.eventListenerUtils.removeListeners();
    }
}
